export function normalizeFinancialProfessionalAnswer(value) {
  if (value == null) return "";

  const normalized = String(value).trim().toLowerCase();
  if (["yes", "y", "true", "1"].includes(normalized)) return "yes";
  if (["no", "n", "false", "0"].includes(normalized)) return "no";
  return "";
}

export function isProfileComplete(profile) {
  if (!profile) return false;
  if (profile.is_admin === true) return true;

  return Boolean(
    String(profile.first_name ?? "").trim() &&
      String(profile.last_name ?? "").trim() &&
      String(profile.tenant_id ?? "").trim() &&
      normalizeFinancialProfessionalAnswer(profile.is_financial_pro)
  );
}
